/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/jsx-no-undef */
import './ReviewStudent.css';
import CamAppIcon from 'components/icons/CamAppIcon';
import toast from 'react-hot-toast'
import { Tab, Typography, Grid, } from '@mui/material';
import ScrollableTabs from 'components/shared/ScrollableTabs';
import React from 'react';
import RPersonalInformation, { buildParentTabPageStatusClassName} from './components/RPersonalInformation';
import CustomTabPanel from './components/TabPanel';
import { Button, OverlayTrigger, Tooltip  } from 'react-bootstrap';
import counselorServices from 'services/counselorServices';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { routers } from 'router/router';
import {
  checkModule,
  logout,
  sanitizeCheckedModule,
  setPartners,
} from 'app/basicInformationSlice/basicInformationSlice';
import { setStudentList } from 'app/counselorSlice';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import RFamily from './components/RFamily';
import REducation from './components/REducation';
import RTests from './components/RTests';
import RCoursesAndGrades from './components/RCoursesAndGrades';
import RActivitiesAndHonors from './components/RActivitiesAndHonors';
import RAdditionalInfo from './components/RAdditionalInfo';
import { DocumentsTab } from './components/documents/DocumentsTab';
import { checkEnableParseJSON, getDefaultCounselorStudentId } from 'components/helper/helper';
import Modal from 'react-bootstrap/Modal';
import RCollege from './components/RCollege';
import { setCheckModule } from 'app/basicInformationSlice/basicInformationSlice';
import { usePageStatus } from 'hooks/usePageStatus';
import { PAGE_NAME, STRIPE_PRICE_NAME, STRIPE_SUBSCRIPTION_STATUS, USER_ROLE } from 'constants/common';
import websocketService from 'services/websocketService';
import { getAccessToken, getUserId, removeUserId, removeAccessToken } from 'utils/sessionStorage';
import { getCamBaseUrl, isGradMapSessionValid, notifyCamSessionExpired, openInCam, showCamPopupBlockedToast } from 'utils/camAuth';
import collegeServices from 'services/collegeServices';
import HeaderV2Gate from 'components/studentActionBar/HeaderV2Gate';
import StudentActionBar from 'components/studentActionBar/StudentActionBar';
import basicInformationServices from 'services/basicInformationApi';
import { LikelihoodRanges } from 'constants/likelihoodBalance';
import { normalizeLikelihoodRanges } from 'constants/likelihoodBalance';
// import { useFormik } from 'formik';
// import Cookies from 'js-cookie';
// import { authenticateSettings } from 'components/helper/appConfig';
// import { NoteModal, NoteStatus } from './counselor.types';
// import moment from 'moment';
// import collegeServices from 'services/collegeServices';
// import CheckboxInput from 'components/input/CheckboxInput';
// import { getHousehold } from 'app/family/familySlice';
// import { getGeneral } from 'app/testingSlice/testingSlice';
// import RGPAForecaster from './components/RGPAForecaster';
// import Checkbox from '@mui/material/Checkbox';
// import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
// import { useWebSocket } from 'hooks/useWebSocket';
// import ChatBox from 'components/Chatbox';
// import FloatingChatButton from 'components/FloatingChatButton';
// import FacebookStyleSidebar from 'components/layout/ChatlistSidebar';

// const initValues: {
//   content: string;
//   status: NoteStatus;
//   isStudentReviewed: boolean;
//   isCounselorApproved: boolean;
// } = {
//   content: '',
//   status: '',
//   isStudentReviewed: false,
//   isCounselorApproved: false,
// };
// const tabContent: any = {
//   1: 'Personal1111 Information',
//   2: 'Family',
//   3: 'Education',
//   4: 'Tests',
//   5: 'Courses & Grades',
//   6: 'Activities & Honors',
//   7: 'Additional Info',
//   9: 'GPA Forecaster',
// };

export const BuildStatusColor = ({ status }: { status: string }) => {
  const classbuild =
    status === 'Review Feedback'
      ? 'text-danger'
      : status === 'Approved'
      ? 'text-success'
      : 'text-primary';
  return <Typography className={classbuild}>{status}</Typography>;
};

const ReviewStudent = () => {
  const params: { id: string } = useParams();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const history = useHistory();
  let studentId = getUserId();
  let token = getAccessToken();
  const [showModalNoStudent, setShowModalNoStudent] = React.useState(false);
  const [studentSubscriptionInfoForView, setStudentSubscriptionInfoForView] = React.useState<any>(null);
  const [showUpgradeRequiredModal, setShowUpgradeRequiredModal] = React.useState(false);
  const [value, setValue] = React.useState(1);
  const [checkedData, setCheckedData] = React.useState(checkModule);
  const [currentModuleId, setCurrentModuleId] = React.useState('1.1');
  const [studentList, setStudents] = React.useState<any[]>([]);
  const [counselor, setCounselor] = React.useState<any>(null);
  const rawRouteStudentId = params?.id;
  const safePageStatusStudentId =
    rawRouteStudentId != null &&
    String(rawRouteStudentId).trim() !== '' &&
    Number.isFinite(Number(rawRouteStudentId)) &&
    Number(rawRouteStudentId) > 0
      ? String(Number(rawRouteStudentId))
      : '';

  const { pageStatus, refreshPageStatus } = usePageStatus({ studentId: safePageStatusStudentId });
  console.log('pageStatus:', pageStatus);

  const personalStore = useAppSelector((store) => store.basicInformation.myBasicInformation);
  const role = useAppSelector((store) => store.family.roleFamily);
  console.log('role: ',role);
  const myGeneral = useAppSelector((store) => store.testing.myGeneral);

  // Helper function to calculate roleTest from myGeneral
  const buildRoleTest = React.useCallback((general: any) => {
    const all_tests_wish_report_array = checkEnableParseJSON(
      general?.all_tests_wish_report_array ?? {}
    );

    console.log('all_tests_wish_report_array:', all_tests_wish_report_array);

    return {
      satTest: all_tests_wish_report_array?.is_SAT,
      actTest: all_tests_wish_report_array?.is_ACT,
      actSubjectTest: all_tests_wish_report_array?.is_AP_Subject,
      ibSubjectTest: all_tests_wish_report_array?.is_IB_Subject,
      clepTest: all_tests_wish_report_array?.is_CLEP,
    };
  }, []);

  // Calculate roleTest from myGeneral (only if myGeneral belongs to the student being reviewed)
  const roleTest = React.useMemo(() => {
    if (myGeneral && Number(myGeneral.student_id) === Number(params.id)) {
      return buildRoleTest(myGeneral);
    }
    return {
      satTest: false,
      actTest: false,
      actSubjectTest: false,
      ibSubjectTest: false,
      clepTest: false,
    };
  }, [myGeneral, params.id, buildRoleTest]);
  
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setCurrentModuleId(`${newValue}.1`);
    const path = routers.viewStudent.path.replace(':id', params?.id || '');
    history.replace(`${path}?tab=${newValue}`);
  };

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const getCounselorFromStudentId = async () => {
    studentId = getUserId();
    const res: any = await counselorServices.getPartner((studentId));
    const student = res[0]?.student_id;

    if (student) {
      const counselor = await counselorServices.getCounselors(student);
      setCounselor(counselor.find((counselor: any) => counselor.partner_role === "counselor"));
    }
    return res[0];
  };

  const getData = async () => {
    studentId = getUserId();
    token = getAccessToken();
    try {
      if (token && studentId) {
        const res: any = await counselorServices.getPartner(studentId);
        setStudents(res);
        dispatch(setStudentList(res)); // for update sibar menu
        dispatch(setPartners(res));
        const routeId = params?.id;
        const isValidRouteStudentId =
          routeId != null &&
          String(routeId).trim() !== '' &&
          Number.isFinite(Number(routeId)) &&
          Number(routeId) > 0;

        if (res.length && !isValidRouteStudentId) {
          const firstStudentId = getDefaultCounselorStudentId(res);
          history.push(routers.viewStudent.path.replace(':id', String(firstStudentId)));
          
          // Auto-join session room with first student (session = session_studentId)
          try {
            console.log('Auto-joining session room with first student:', firstStudentId);
            await websocketService.connect();
            await websocketService.joinSession(firstStudentId);
            console.log('Successfully joined session room with first student');
          } catch (error) {
            console.error('Error auto-joining session room with first student:', error);
            // Don't prevent navigation on error
          }
        } else if (!res.length) {
          setShowModalNoStudent(true);
        }
      } else {
        handleLogout();
      }
    } catch (ex) {
      console.log('Error: ', ex);
    }
  };

  React.useEffect(() => {
    getData();

    if (personalStore?.user_role === 'parent') {
      getCounselorFromStudentId();
    }
  }, [personalStore?.user_role]);

  const getPartnerDataById = async () => {
    if (params?.id !== ':id') {
      studentId = getUserId();
      token = getAccessToken();
      try {
        if (token && studentId) {
          let item: any = studentList.find((e) => e.student_id.toString() === params?.id);
          if (item) {
            let loadedCheckModule =
              checkEnableParseJSON(item.notes_array, {
                checkModule,
                notes: [],
              })?.checkModule ?? checkModule;

            if (loadedCheckModule === null) {
              loadedCheckModule = { ...checkModule };
            } else {
              // force sanitizeCheckedModule
              loadedCheckModule = sanitizeCheckedModule(loadedCheckModule);
            }
            setCheckedData(loadedCheckModule);
            dispatch(setCheckModule(loadedCheckModule));
            
            // Handle session room joining when switching to a specific student (session = session_studentId)
            const selectedStudentId = Number(params.id);

            try {
              const currentSession = websocketService.getCurrentSessionData();
              if (currentSession?.student_id === selectedStudentId) {
                console.log('Already in session with this student, skipping...');
              } else {
                if (websocketService.hasJoinedSessionRoom()) {
                  await websocketService.leaveSession();
                }
                console.log('Joining session with student:', selectedStudentId);
                await websocketService.joinSession(selectedStudentId);
                console.log('Successfully joined session with student');
              }
            } catch (error) {
              console.error('Error handling counselor session:', error);
            }
          }
        } else {
          handleLogout();
        }
      } catch (ex) {
        console.log('Error: ', ex);
      }
    }
  };

  React.useEffect(() => {
    getPartnerDataById();
  }, [params?.id, studentList, pageStatus]);

  React.useEffect(() => {
    const tabParam = new URLSearchParams(location.search).get('tab');
    const tabNum = tabParam ? parseInt(tabParam, 10) : 1;
    const validTab = [1, 2, 3, 4, 5, 6, 7, 8, 10].includes(tabNum) ? tabNum : 1;
    setValue(validTab);
  }, [params?.id, location.search]);

  const isDemoStudentEmailValue = (email?: string) => {
    const e = (email ?? '').trim().toLowerCase();
    return (
      e === 'student-demo@collegeplanningsource.com' ||
      e === 'student-demo@gradmap.com'
    );
  };

  const parentShouldBlockStudentAccess = (info: any) => {
    if (!info) return false;
    const plan = info?.subcription_plan;
    const status = info?.subcription_status;
    if (plan === STRIPE_PRICE_NAME.GradMapStarter) return true;
    // Parent has no own subscription — only gate when the opened child is canceled
    if (status === STRIPE_SUBSCRIPTION_STATUS.canceled) return true;
    return false;
  };

  // Parent viewing student: block if child is Starter or canceled (except demo student)
  React.useEffect(() => {
    if (personalStore?.user_role === USER_ROLE.parent && params?.id && params.id !== ':id') {
      basicInformationServices
        .getEnableExtention(params.id)
        .then((info: any) => {
          setStudentSubscriptionInfoForView(info);
          const item = studentList.find((e: any) => e.student_id?.toString() === params?.id);
          if (isDemoStudentEmailValue(item?.student_info?.email)) {
            setShowUpgradeRequiredModal(false);
            return;
          }
          if (parentShouldBlockStudentAccess(info)) {
            setShowUpgradeRequiredModal(true);
          }
        })
        .catch(() => {
          setStudentSubscriptionInfoForView(null);
        });
    } else {
      setStudentSubscriptionInfoForView(null);
      setShowUpgradeRequiredModal(false);
    }
  }, [personalStore?.user_role, params?.id, studentList]);

  // Don't block or show upgrade modal for demo student email
  React.useEffect(() => {
    const item = studentList.find((e: any) => e.student_id?.toString() === params?.id);
    if (isDemoStudentEmailValue(item?.student_info?.email)) {
      setShowUpgradeRequiredModal(false);
    }
  }, [studentList, params?.id]);

  // Save refreshPageStatus to the reference so that it can be accessed in the callback.
  const refreshPageStatusRef = React.useRef(refreshPageStatus);
  
  // Update ref when value changes
  React.useEffect(() => {
    refreshPageStatusRef.current = refreshPageStatus;
  }, [refreshPageStatus]);

  // Listen to the websocket event page:page_progress_updated to refresh tab status styles
  // Use sockets directly to manage individual listeners
  React.useEffect(() => {
    let intervalId: NodeJS.Timeout | null = null;
    
    const handlePageProgressUpdate = (data: any) => {
      console.log('Page progress updated in ReviewStudent:', data);
      refreshPageStatusRef.current();
    };

    // Function để setup listener
    const setupWebSocketListener = () => {
      try {
        const socket = websocketService.getSocket();
        if (socket && websocketService.isSocketConnected()) {
         // Remove the old listener if present (to avoid duplication)
          socket.off('page:page_progress_updated', handlePageProgressUpdate);
          // Set up a new listener
          socket.on('page:page_progress_updated', handlePageProgressUpdate);
          return true;
        }
        return false;
      } catch (error) {
        console.error('Error setting up websocket listener:', error);
        return false;
      }
    };

    // Get sockets directly from websocketService to remove specific listeners
    const initializeListener = async () => {
      try {
        // Ensure the websocket is connected
        if (!websocketService.isSocketConnected()) {
          await websocketService.connect();
        }
        setupWebSocketListener();
      } catch (error) {
        console.error('Error initializing websocket listener:', error);
       // Retry after 1 second if error
        setTimeout(() => {
          setupWebSocketListener();
        }, 1000);
      }
    };

    initializeListener();

    // Reconfigure listener when socket reconnects
    const socket = websocketService.getSocket();
    if (socket) {
      const onConnect = () => {
        setupWebSocketListener();
      };
      
      socket.on('connect', onConnect);
      socket.on('reconnect', onConnect);

      // Check and reset the listener periodically (every 3 seconds) 
      // This ensures the listener is always active even if removed by another hook
      intervalId = setInterval(() => {
        setupWebSocketListener();
      }, 3000);

      // Cleanup: Remove this specific listener when the component is unmounted
      return () => {
        if (intervalId) {
          clearInterval(intervalId);
        }
        socket.off('page:page_progress_updated', handlePageProgressUpdate);
        socket.off('connect', onConnect);
        socket.off('reconnect', onConnect);
      };
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
      const socket = websocketService.getSocket();
      if (socket) {
        socket.off('page:page_progress_updated', handlePageProgressUpdate);
      }
    };
  }, [refreshPageStatus, params?.id]); // Setup again when refreshPageStatus or params.id changes

  const getRequiredPagesForParentTab = React.useCallback(
    (groupId: number): string[] => {
      switch (groupId) {
        case 1:
          return [
            PAGE_NAME.BASIC_INFORMATION,
            PAGE_NAME.CONTACT_DETAILS,
            PAGE_NAME.DEMOGRAPHICS,
            PAGE_NAME.CITIZENSHIP,
            PAGE_NAME.CBO,
            PAGE_NAME.OTHER,
          ];
        case 2: {
          // Household is always shown, so it's always required.
          // Every other sub-tab is only rendered (and reviewable) when its
          // matching role flag is true, so it must only be required then —
          // otherwise the Family parent tab could never turn "complete".
          const pages = [PAGE_NAME.HOUSEHOLD];
          if (role?.parentNo1) {
            pages.push(PAGE_NAME.PARENT_1);
          }
          if (role?.parentNo2) {
            pages.push(PAGE_NAME.PARENT_2);
          }
          if (role?.siblings) {
            pages.push(PAGE_NAME.SIBLINGS);
          }
          if (role?.legalGuardian) {
            pages.push(PAGE_NAME.LEGAL_GUARDIAN);
          }
          if (role?.stepParent1) {
            pages.push(PAGE_NAME.STEP_PARENT_1);
          }
          if (role?.stepParent2) {
            pages.push(PAGE_NAME.STEP_PARENT_2);
          }

          console.log('groupId:', groupId);
          console.log('pages2: ', pages);
          return pages;
        }
        case 3:
          return [
            PAGE_NAME.ENROLIMENT_STATUS,
            PAGE_NAME.HIGH_SCHOOL,
            PAGE_NAME.ENROLIMENT_STATUS,
            PAGE_NAME.COLLEGE_AND_UNIVERSITY,
          ];
        case 4: {
          const pages: string[] = [PAGE_NAME.GENERAL_TEST];
          if (roleTest?.satTest || roleTest?.actTest) {
            if (roleTest?.satTest) {
              pages.push(PAGE_NAME.SAT_TEST);
            }
            if (roleTest?.actTest) {
              pages.push(PAGE_NAME.ACT_TEST);
            }
          }
          if (roleTest?.actSubjectTest) {
            pages.push(PAGE_NAME.ACT_SUBJECT_TEST);
          }
          if (roleTest?.ibSubjectTest) {
            pages.push(PAGE_NAME.IB_SUBJECT_TEST);
          }
          if (roleTest?.clepTest) {
            pages.push(PAGE_NAME.CLEP_TEST);
          }
          return pages;
        }
        case 5:
          return [
            PAGE_NAME.GENERAL_COURSE,
            PAGE_NAME.GRADE_9,
            PAGE_NAME.GRADE_10,
            PAGE_NAME.GRADE_11,
            PAGE_NAME.GRADE_12,
            PAGE_NAME.COLLEGE_COURSE,
          ];
        case 6:
          return [
            PAGE_NAME.ACTIVITIES,
            PAGE_NAME.HONORS,
            PAGE_NAME.EDUCATIONAL_PROGRAMS,
            PAGE_NAME.RESPONSIBILITIES_AND_CIRCUMSTANCES,
          ];
        case 7:
          return [
            PAGE_NAME.ADDITIONAL_INFO,
            PAGE_NAME.ADDITIONAL_INFO_1,
            PAGE_NAME.ADDITIONAL_INFO_2,
            PAGE_NAME.ADDITIONAL_INFO_3,
          ];
        case 8:
          return [];
        case 9:
          return [PAGE_NAME.GPA_FORECASTER];
        default:
          return [];
      }
    },
    [role, roleTest]
  );

  const currentStudentItem = studentList.find((e: any) => e.student_id?.toString() === params?.id);
  const currentStudentEmail = currentStudentItem?.student_info?.email;
  const isDemoStudentEmail = isDemoStudentEmailValue(currentStudentEmail);

  const isBlockedByPlan =
    personalStore?.user_role === USER_ROLE.parent &&
    parentShouldBlockStudentAccess(studentSubscriptionInfoForView) &&
    !isDemoStudentEmail;

  const handleOpenInCam = async () => {
    let hasToken = !!getAccessToken();
    if (!hasToken) {
      notifyCamSessionExpired();
      return;
    }

    // Token is present but may already be expired/revoked server-side —
    // confirm with the backend before handing it off to CAM.
    const sessionValid = await isGradMapSessionValid();
    if (!sessionValid) {
      notifyCamSessionExpired();
      return;
    }

    if (!getCamBaseUrl()) {
      toast.error('CAM is not configured. Please contact support.');
      return;
    }

    const studentIdNow = currentStudentItem.student_id;
    if (!studentIdNow) return;

    let camOpenContext: {
      requirementsReturnTo: string | null;
      likelihoodRanges: LikelihoodRanges;
    } | null = null;

    try {
      let ctx1 = await collegeServices.getCamOpenContext(studentIdNow);
      camOpenContext = {
        requirementsReturnTo: ctx1.requirementsReturnTo,
        likelihoodRanges: normalizeLikelihoodRanges(ctx1.likelihoodRanges),
      };
    } catch {
      camOpenContext = null;
    }

    try {
      let legacyId = undefined
      const ctx = await collegeServices.getCamOpenContext(
        studentIdNow,
        legacyId != null && !Number.isNaN(legacyId) ? legacyId : undefined,
      );
      const returnTo = ctx.requirementsReturnTo ?? camOpenContext?.requirementsReturnTo ?? '/';
      if (!openInCam(returnTo)) {
        showCamPopupBlockedToast(toast.error);
      }
    } catch {
      const fallback = camOpenContext?.requirementsReturnTo ?? '/';
      if (!openInCam(fallback)) {
        showCamPopupBlockedToast(toast.error);
      }
    }
  };

  return (
    <div className="pt-1">
      {isBlockedByPlan ? (
        <Grid container sx={{ width: '100%', minHeight: 'calc(100vh - 100px)', alignItems: 'center', justifyContent: 'center' }}>
          <Grid item xs={12} sx={{ textAlign: 'center', padding: 3 }}>
            <Typography color="textSecondary">Please upgrade your child's plan to see the detail information.</Typography>
          </Grid>
        </Grid>
      ) : (
      <Grid container sx={{ width: '100%', minHeight: 'calc(100vh - 100px)' }}>
        <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column' }}>
          <div className="gm-profile-sticky">
          {personalStore?.user_role === USER_ROLE.counselor ? (
            <StudentActionBar
              studentId={params?.id || ''}
              viewerRole="counselor"
              studentFirstName={currentStudentItem?.student_info?.first_name || ''}
              studentName={[currentStudentItem?.student_info?.first_name, currentStudentItem?.student_info?.last_name].filter(Boolean).join(' ')}
              classYear={currentStudentItem?.student_info?.year_finish_high_school}
              email={currentStudentEmail}
              showHome
            />
          ) : personalStore?.user_role === USER_ROLE.student ||
            personalStore?.user_role === USER_ROLE.parent ? (
            <HeaderV2Gate studentId={params?.id || ''}>
            <StudentActionBar
              studentId={params?.id || ''}
              viewerRole={personalStore.user_role}
              studentFirstName={currentStudentItem?.student_info?.first_name || ''}
              studentName={[currentStudentItem?.student_info?.first_name, currentStudentItem?.student_info?.last_name].filter(Boolean).join(' ')}
              classYear={currentStudentItem?.student_info?.year_finish_high_school}
            />
            </HeaderV2Gate>
          ) : null}
          <ScrollableTabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            className="mb-2"
            sx={{
              backgroundColor: '#fff',
              paddingTop: '8px',
              paddingBottom: '8px',
            }}
          >
            <Tab
              value={1}
              label="Personal Information"
              className={`styled-tab${buildParentTabPageStatusClassName(
                pageStatus,
                getRequiredPagesForParentTab(1)
              )}`}
            />
            <Tab
              value={2}
              label="Family"
              className={`styled-tab${buildParentTabPageStatusClassName(
                pageStatus,
                getRequiredPagesForParentTab(2)
              )}`}
            />
            <Tab
              value={3}
              label="Education"
              className={`styled-tab${buildParentTabPageStatusClassName(
                pageStatus,
                getRequiredPagesForParentTab(3)
              )}`}
            />
            <Tab
              value={5}
              label="Courses & Grades"
              className={`styled-tab${buildParentTabPageStatusClassName(
                pageStatus,
                getRequiredPagesForParentTab(5)
              )}`}
            />
            <Tab
              value={4}
              label="Tests"
              className={`styled-tab${buildParentTabPageStatusClassName(
                pageStatus,
                getRequiredPagesForParentTab(4)
              )}`}
            />
            <Tab
              value={6}
              label="Activities & Honors"
              className={`styled-tab${buildParentTabPageStatusClassName(
                pageStatus,
                getRequiredPagesForParentTab(6)
              )}`}
            />
            <Tab
              value={7}
              label="Additional Info"
              className={`styled-tab${buildParentTabPageStatusClassName(
                pageStatus,
                getRequiredPagesForParentTab(7)
              )}`}
            />
            {/* <Tab
              value={9}
              label="GPA Forecaster"
              className={`styled-tab${buildParentTabPageStatusClassName(
                pageStatus,
                getRequiredPagesForParentTab(9)
              )}`}
            /> */}
            <Tab
              value={8}
              label="Colleges"
              className={`styled-tab${buildParentTabPageStatusClassName(
                pageStatus,
                getRequiredPagesForParentTab(8)
              )}`}
            />
            <Tab value={10} label="Documents" className="styled-tab" />
            <OverlayTrigger
              placement={'right'}
              overlay={
                <Tooltip id={`tooltip-cam`}>
                  <strong>Open in CAM</strong>
                </Tooltip>
              }
            >
              <Button
                className="py-3 border-top rounded-0 text-field-light pt-2"
                variant="outline"
                onClick={handleOpenInCam}
              >
                <CamAppIcon className="my-3" />
                <span className="ms-1">Open in CAM</span>
              </Button>
            </OverlayTrigger>
          </ScrollableTabs>
          </div>
          <div style={{ flex: 1}}>
            <CustomTabPanel value={value} index={1}>
              <RPersonalInformation setCurrentModuleId={setCurrentModuleId} isCounselor />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <RFamily setCurrentModuleId={setCurrentModuleId} isCounselor />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={3}>
              <REducation setCurrentModuleId={setCurrentModuleId} isCounselor />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={4}>
              <RTests setCurrentModuleId={setCurrentModuleId} isCounselor />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={5}>
              <RCoursesAndGrades setCurrentModuleId={setCurrentModuleId} isCounselor />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={6}>
              <RActivitiesAndHonors setCurrentModuleId={setCurrentModuleId} isCounselor />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={7}>
              <RAdditionalInfo setCurrentModuleId={setCurrentModuleId} isCounselor />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={8}>
              <RCollege setCurrentModuleId={setCurrentModuleId} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={10}>
              {Number(params.id) > 0 && (
                <DocumentsTab
                  studentId={Number(params.id)}
                  viewerRole={
                    personalStore?.user_role === 'parent'
                      ? 'parent'
                      : personalStore?.user_role === 'student'
                        ? 'student'
                        : 'counselor'
                  }
                  studentFirstName={currentStudentItem?.student_info?.first_name || ''}
                />
              )}
            </CustomTabPanel>
            {/* <CustomTabPanel value={value} index={9}>
              <RGPAForecaster setCurrentModuleId={setCurrentModuleId} />
            </CustomTabPanel> */}
          </div>
        </Grid>
        {/* <Grid 
          item 
          xs={12} 
          md={4} 
          sx={{ 
            marginTop: { md: '48px' },
            height: { xs: '500px', md: 'calc(100vh - 150px)' },
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <FacebookStyleSidebar
            studentList={studentList}
            personalStore={personalStore}
            counselor={counselor}
            isCounselor={personalStore?.user_role === 'counselor' ? true : false}
            isParent={personalStore?.user_role === 'parent' ? true : false}
            counselorId={Number(Cookies.get('userId'))}
          />
        </Grid> */}
      </Grid>
      )}

      <Modal show={showUpgradeRequiredModal} onHide={() => setShowUpgradeRequiredModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Upgrade required</Modal.Title>
        </Modal.Header>
        <Modal.Body>Please upgrade your child's plan to see the detail information.</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setShowUpgradeRequiredModal(false)}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showModalNoStudent} onHide={() => setShowModalNoStudent(false)}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>There is not any student to review</Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => setShowModalNoStudent(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ReviewStudent;
